import React from "react";
import redux from "../../assets/5848309bcef1014c0b5e4a9a.png";
import nextJs from "../../assets/800px-Nextjs-logo.svg.png";
import expressJs from "../../assets/Status_iucn_EX_icon.svg.png";
import materialUi from "../../assets/meterialui.png";
import react from "../../assets/React-icon.svg.png";
import JavaScript from "../../assets/javascript-logo-transparent-logo-javascript-images-3.png";
import nodeJs from "../../assets/nodejs-logo-FBE122E377-seeklogo.com.png";
import mongoDB from "../../assets/MongoDB_Logo.svg";
import Bootstrap from "../../assets/Bootstrap_logo.svg.png";
import Tailwind from "../../assets/Tailwind_CSS_Logo.svg.png";
import TypeScript from "../../assets/typescript-2.svg";
import css from "../../assets/CSS3_logo.svg.png";
import Html from "../../assets/html-1.svg";
import c from "../../assets/C_Logo.png";
import cpp from "../../assets/ISO_C++_Logo.svg.png";
import csharp from "../../assets/csharp.png";
import java from "../../assets/java.png";
import sql from "../../assets/sql.png";
import dsa from "../../assets/dsa.png";
import netlify from "../../assets/netlify-logo-png-transparent.png";
import vercel from "../../assets/vercel-icon-512x449-3422jidz.png";
import gitHub from "../../assets/github-logo.png";
import firebase from "../../assets/firebase.png";
import jwt from "../../assets/jwt.png";

const MySkills = () => {
  return (
    <div className="font-serif my-5 md:mb-20 md:mx-32 mx-5" id="skills">
      <h1 className="text-5xl text-center">My Skills</h1>
      <h1 className="text-xl text-center">
        Here are some Skills and Tools what i know
      </h1>

      <div className=" ">
        <div className="grid md:grid-cols-4  grid-cols-2 gap-5 my-5 ">
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img
              src={JavaScript}
              alt=""
              className="md:w-16 md:h-16 w-14 h14 "
            />
            <h1>JavaScript</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={react} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>React.Js</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={nodeJs} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>Node.Js</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={mongoDB} alt="" className="md:w-24 md:h-16 w-14 h14 " />
            <h1>MongoDB</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img
              src={TypeScript}
              alt=""
              className="md:w-16 md:h-16 w-14 h14 "
            />
            <h1>TypeScript</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={redux} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>Redux</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={nextJs} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>Next.Js</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={expressJs} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>Express.Js</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={Bootstrap} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>Bootstrap</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={Tailwind} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>Tailwind</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img
              src={materialUi}
              alt=""
              className="md:w-16 md:h-16 w-14 h14 "
            />
            <h1>Material UI</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={css} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>CSS</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={Html} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>HTML</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={c} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>C</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={cpp} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>C++</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={csharp} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>C#</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={java} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>Java</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={sql} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>SQL</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={dsa} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>Data Structure Algorithm</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={firebase} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>Firebase</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={netlify} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>Netlify</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={vercel} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>Vercel</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={gitHub} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>GitHub</h1>
          </div>
          <div
            className="flex justify-between items-center transition-transform duration-500 transform ease-in-out hover:scale-105 shadow-lg px-4 py-2 font-serif md:text-xl rounded-xl relative aos-init aos-animate"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          >
            <img src={jwt} alt="" className="md:w-16 md:h-16 w-14 h14 " />
            <h1>JSON Web Token</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MySkills;
